
<div v-if="afficherBandeau" class="d-flex mt-1 mb-1 justify-content-center">
  <div class="d-flex w-50">
    <b-img-lazy
      v-if="content.image"
      :src="jel_getFichierSrc(content.image)"
      :alt="content.altImage"
      class="image mt-2"
    />
    <div class="titreBandeau mt-0 ml-2 pb-2">
      <Titre
        :content="{
          type: 'sousTitre',
          titre: content.titre,
          classeCSS: 'font-weight-bold mt-0 mb-1',
        }"
      >
      </Titre>
      <p class="mb-1">{{ content.texte }}</p>
      <a :href="content.hyperlien"
        ><u>{{ content.texteHyperlien }}</u></a
      >
    </div>
    <button class="btnVide icone-fermer position-static d-none" @click="fermerBandeau">
      <svg-icon icon-name="icone-fermer-mince"></svg-icon>
    </button>
  </div>
</div>
